<script>
import PageLayout from '../../components/js/Components/UI/PageLayout.vue'
import MainContainer from '../../components/js/Components/UI/Content/MainContainer.vue'
import BlockContent from '../../components/js/Components/UI/Content/BlockContent.vue'
import TableMenu from '../../components/js/Components/UI/Table/TableMenu.vue'
import CardContent from '../../components/js/Components/UI/Content/CardContent.vue'
import DataTable from '../../components/js/Components/UI/Table/DataTable.vue'
import mixinComponent from '../../components/js/Mixins/mixinComponent.js'
import { globalVariablesMixin } from '../../components/js/Mixins/global.js'
import ButtonLink from '../../components/js/Components/UI/Button/ButtonLink.vue'

export default {
  components: {
    BlockContent,
    ButtonLink,
    CardContent,
    DataTable,
    MainContainer,
    PageLayout,
    TableMenu,
  },
  mixins: [mixinComponent, globalVariablesMixin],
  data: () => ({
    selectedStatusId: 0,
    restructuringListRequest: null,
  }),
  computed: {
    columns() {
      return [
        {
          name: 'id',
          title: this.$t('restructuring.list.columns.id'),
          displayable: true,
        },
        {
          name: 'label',
          title: this.$t('restructuring.list.columns.label'),
          formatter: 'custom',
          options: {
            renderer: this.renderLabelCell,
          },
        },
        {
          name: 'actions',
          title: this.$t('restructuring.list.columns.actions'),
          formatter: 'custom',
          options: {
            renderer: this.renderActionsCell,
          },
        },
        {
          name: 'createdAt',
          title: this.$t('restructuring.list.columns.createdAt'),
          style: {
            width: '120px',
          },
          formatter: 'date',
        },
        {
          name: 'createdBy',
          title: this.$t('restructuring.list.columns.createdBy'),
          formatter: 'user',
        },
        {
          name: 'contracts',
          title: this.$t('restructuring.list.columns.contracts'),
          style: {
            width: '120px',
          },
          formatter: 'custom',
          options: {
            renderer: this.renderContractsCell,
          },
        },
        {
          name: 'status',
          title: this.$t('restructuring.list.columns.status'),
          style: {
            width: '120px',
          },
          formatter: 'custom',
          options: {
            renderer: this.renderStatusCell,
          },
        },
      ]
    },
    order() {
      return [
        [3, 'desc'], // createdAt
      ]
    },
    statusFilterOptions() {
      return [
        { id: 0, value: null, name: this.$t('restructuring.list.filters.allStatus') },
        { id: 1, value: 'PENDING', name: this.$t('contract.restructuring.status.PENDING.label') },
        { id: 2, value: 'IN_PROGRESS', name: this.$t('contract.restructuring.status.IN_PROGRESS.label') },
        { id: 3, value: 'DONE', name: this.$t('contract.restructuring.status.DONE.label') },
        { id: 4, value: 'CANCELED', name: this.$t('contract.restructuring.status.CANCELED.label') },
      ]
    },
    activeFilterOption() {
      return this.statusFilterOptions.find(({ id }) => this.selectedStatusId === id)
    },
    apiEndpoint() {
      const url = 'contracts/restructuring'

      const queryParams = new URLSearchParams()

      if (this.activeFilterOption.value !== null) {
        queryParams.set('status', this.activeFilterOption.value)
      }

      return url + '?' + queryParams.toString()
    },
  },
  methods: {
    cancelPendingRequest() {
      this.restructuringListRequest?.cancel()
      this.restructuringListRequest = null
    },
    async fetch(callback) {
      this.cancelPendingRequest()

      const getJsonPromise = this.getJSON(this.apiEndpoint)
      this.restructuringListRequest = getJsonPromise
      const data = await getJsonPromise
      callback({ data })
    },
    renderStatusCell(data) {
      let badgeStyle
      switch (data) {
        case 'IN_PROGRESS':
          badgeStyle = 'bg-primary'
          break
        case 'DONE':
          badgeStyle = 'bg-success'
          break
        case 'CANCELED':
          badgeStyle = 'bg-secondary text-dark'
          break
        default:
          badgeStyle = 'bg-warning text-dark'
      }

      return `<span class="badge ${badgeStyle} px-2" data-search="${data}">${this.$t(`contract.restructuring.status.${data}.label`)}</span>`
    },
    renderActionsCell(data) {
      return data.map(({ actionType }) => this.$t(`contract.restructuring.types.${actionType}.label`)).join(', ')
    },
    renderContractsCell(data) {
      return data.length
    },
    renderLabelCell(data, type, row) {
      return `<a href="/#/restructuration/${row.id}" target="_blank">${data}</a>`
    },
  },
  watch: {
    selectedStatusId() {
      this.cancelPendingRequest()
      this.$refs.restructuringList.renderDataTable()
    },
  },
}
</script>
<template>
  <PageLayout menu="restructuring">
    <MainContainer :title="$t('menu.contractRestructuring')">
      <BlockContent>
        <TableMenu
          v-model:status="selectedStatusId"
          :submenu-labels="statusFilterOptions"
          :show-download-button="false"
          :show-filters-button="false"
          :show-filters="false"
          :show-calendar-filter="false"
        >
          <template #right>
            <ButtonLink type="add" label="restructuring.actions.add" :href="{ name: Routes.RESTRUCTURING_CREATE }" />
          </template>
        </TableMenu>

        <CardContent class="pt-3">
          <DataTable id="restructuringList" ref="restructuringList" :columns="columns" :order="order" :fetch="fetch" />
        </CardContent>
      </BlockContent>
    </MainContainer>
  </PageLayout>
</template>
